import {Injectable} from "@angular/core";
import {CanMatch, Route, UrlSegment, UrlTree} from "@angular/router";
import {Observable, of, switchMap, shareReplay} from "rxjs";
import {AuthService} from "app/core/auth/auth.service";
// import {Router} from "@angular/router";
// import {catchError} from "rxjs";
// import {InventarioService} from "app/modules/inventario/inventario.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanMatch {
  // private _formStatusCache: Map<string, Observable<boolean | UrlTree>> =
  //   new Map();
  private _authCheckCache$?: Observable<boolean>;

  constructor(
    private _authService: AuthService
    // private _router: Router,
    // private _inventarioService: InventarioService
  ) {}

  canMatch(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> {
    return this._check(segments);
  }

  private _check(segments: UrlSegment[]): Observable<boolean | UrlTree> {
    if (!this._authCheckCache$) {
      this._authCheckCache$ = this._authService.check().pipe(shareReplay(1));
    }

    return this._authCheckCache$.pipe(
      // Login ainda não funciona neste sistema: libera o acesso sem
      // redirecionar quando todos os formulários estão preenchidos.
      switchMap(() => of(true))
      // switchMap(authenticated =>
      //   authenticated ? of(true) : this._checkFormStatus(segments)
      // )
    );
  }

  // private _checkFormStatus(
  //   segments: UrlSegment[]
  // ): Observable<boolean | UrlTree> {
  //   const idInventario = this._getIdInventarioFromSegments(segments);
  //
  //   if (!idInventario || idInventario === "novo") {
  //     console.warn("🚫 Sem inventário válido. Acesso permitido.");
  //     return of(true);
  //   }
  //
  //   const status$ = this._statusDoInventario(segments, idInventario);
  //
  //   if (this._inventarioService.inventarioJaConfirmado(idInventario)) {
  //     status$.subscribe(result => {
  //       if (result instanceof UrlTree) {
  //         this._router.navigateByUrl(result);
  //       }
  //     });
  //     return of(true);
  //   }
  //
  //   return status$;
  // }
  //
  // private _statusDoInventario(
  //   segments: UrlSegment[],
  //   idInventario: string
  // ): Observable<boolean | UrlTree> {
  //   if (this._formStatusCache.has(idInventario)) {
  //     return this._formStatusCache.get(idInventario)!;
  //   }
  //
  //   const request$ = this._inventarioService
  //     .getStatusFormulario(idInventario)
  //     .pipe(
  //       switchMap(status => {
  //         const todosPreenchidos = Object.values(
  //           status?.formulario || {}
  //         ).every(value => value === true);
  //
  //         if (todosPreenchidos) {
  //           console.warn(
  //             "✅ Todos os formulários foram preenchidos. Redirecionando para login."
  //           );
  //           const redirectURL = `/${segments.join("/")}`;
  //           return of(
  //             this._router.parseUrl(`sign-in?redirectURL=${redirectURL}`)
  //           );
  //         }
  //
  //         return of(true);
  //       }),
  //       catchError(error => {
  //         console.error("❌ Erro ao verificar status do formulário:", error);
  //         return of(true);
  //       }),
  //       shareReplay(1)
  //     );
  //
  //   this._formStatusCache.set(idInventario, request$);
  //   return request$;
  // }
  //
  // private _getIdInventarioFromSegments(segments: UrlSegment[]): string | null {
  //   return segments.length > 2 ? segments[2].path : null;
  // }
}
